import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  IconButton,
  Tooltip
} from "@mui/material";
import ProfileHeader from "../../../components/ProfileHeader";
import DashboardApi from "../../../api/DashboardApi";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import {
  DataGridPremium,
  GridColDef,
  esES,
  useGridRootProps,
  GridToolbarFilterButton,
  GridToolbarContainer,
} from "@asf-libs/x-data-grid-premium";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ProfileContext from "../profile/ProfileContext";
import moment from "moment";
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function DocumentsVto() {
  const location = useLocation();
  const [filterDocumentType, setFilterDocumentType] = useState<string>(
    location?.state?.filterDocumentType || ""
  );
  const [gridFilterModel, setGridFilterModel] = useState({
    items: filterDocumentType
        ? [{ field: "typedoc", operator: "equals", value: filterDocumentType }]
        : []
    });
  const [rows, setRows] = useState([]);
  const [sortModel, setSortModel] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const filterInitialized = useRef(false);

  useEffect(() => {
    if (filterDocumentType && !filterInitialized.current) {
      setGridFilterModel({
        items: [
          {
            field: "typedoc",
            operator: "equals",
            value: filterDocumentType,
          },
        ],
      });
      filterInitialized.current = true;
    }
  }, [filterDocumentType]);

  const handleDownloadExcel = async () => {
    try {
      const params: any = {
        "showDashboard.equals": "true",
        "remarks.equals": "ALREADY_EXPIRED",
        "status.equals": "Verificado",
      };

      if (sortModel.length > 0) {
        var field;
        if(sortModel[0].field === "typedoc"){
            field = "documentTypeName";
        }if(sortModel[0].field === "subtypedoc"){
            field = "documentSubTypeName";
        }else{
            field = sortModel[0].field;
        }
        const sortParam = field + `,${sortModel[0].sort.toUpperCase()}`;
        params["sort"] = sortParam;
      }

      if (gridFilterModel?.items?.length) {
        gridFilterModel.items.forEach((item: any) => {
          if (item.field && item.operator != null && item.operator !== "") {

          var key;
          var operator;
          var value;
          if(item.operator === "isEmpty"){
            operator = "specified";
            value = "false";
          }else if(item.operator === "isNotEmpty"){
            operator = "specified";
            value = "true";
          }else if(item.operator === "is"){
            operator = "equals";
            value = item.value;
          }else if(item.operator === "not"){
            operator = "notEquals";
            value = item.value;
          }else if(item.operator === "after"){
            operator = "greaterThan";
            value = item.value;
          }else if(item.operator === "onOrAfter"){
            operator = "greaterThanOrEqual";
            value = item.value;
          }else if(item.operator === "before"){
            operator = "lessThan";
            value = item.value;
          }else if(item.operator === "onOrBefore"){
            operator = "lessThanOrEqual";
            value = item.value;
          }else{
            operator = `${item.operator}`;
            value = item.value;
          }

          if(item.field === "typedoc"){
            key = "documentTypeName."+operator;
            params[key] = value;
          }else if(item.field === "subtypedoc"){
            key = "documentSubTypeName."+operator;
            params[key] = value;
          }else{
            key = `${item.field}.`+operator;
            params[key] = value;
          }
        }
      });
     }
      const response = await DashboardApi.generateDocumentExcel(params);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Documentos.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error descargando Excel:", error);
    }
  };

  const CustomToolbar = React.forwardRef<HTMLDivElement>(
    function GridToolbar(props, ref) {
      const { className, ...other } = props as any;
      const rootProps = useGridRootProps();

    if (
      rootProps.disableColumnFilter &&
      rootProps.disableColumnSelector &&
      rootProps.disableDensitySelector
    ) {
      return null;
    }

      return (
        <GridToolbarContainer
          sx={{ background: "#F2F3F1", border: 0, width: "100%" }}
          ref={ref}
          {...other}
        >
          <Box className="indicators-title">
            <Trans i18nKey={`screens.indicators.overdueDocumentTitleList`} />
            <GridToolbarFilterButton sx={{ ml: 10 }} />
            <Tooltip title="Descargar Excel">
                <IconButton color="primary" onClick={handleDownloadExcel}>
                    <FileDownloadIcon/>
                </IconButton>
            </Tooltip>
          </Box>
        </GridToolbarContainer>
      );
    }
  );

  const getColumns = () => {
    const columns: GridColDef[] = [
      {
        field: "dueDate",
        headerName: "Fecha Vto.",
        width: 150,
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        align: "center",
        type: "date",
          valueGetter: (params) => {
            return params.value ? moment(params.value, "DD-MM-YYYY").toDate() : null;
          },
      },
      {
        field: "numberPlate",
        headerName: "Dominio",
        width: 150,
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "brand",
        headerName: "Marca",
        width: 150,
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "model",
        headerName: "Modelo",
        width: 150,
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "typedoc",
        headerName: "Tipo Doc.",
        width: 150,
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "subtypedoc",
        headerName: "Subtipo Doc.",
        width: 150,
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "base",
        headerName: "Base",
        width: 150,
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        align: "center",
      },
    ];
    return columns;
  };

  const [filterValue, setFilterValue] = useState();
  useEffect(() => {
    let active = true;

    (async () => {
      setLoading(true);
      let url =
        "&returnList=true&showDashboard.equals=true&remarks.equals=ALREADY_EXPIRED&status.equals=Verificado";

      if (filterDocumentType) {
        url += `&documentTypeName.equals=${encodeURIComponent(filterDocumentType)}`;
      }

      try {
        const response = await DashboardApi.getDocumentsVto(url);
        const dataRows = response?.data?.map((d: any, index: number) => ({
          id: index,
          dueDate: d.dueDate
            ? moment(d.dueDate).format("DD-MM-YYYY")
            : "",
          numberPlate: d.numberPlate,
          brand: d.brand,
          model: d.model,
          typedoc: d.typedoc,
          subtypedoc: d.subtypedoc,
          base: d.base,
        }));
        if (active) setRows(dataRows || []);
      } catch (e) {
        console.log("Error", e);
      } finally {
        if (active) setLoading(false);
      }
      setLoading(false);
    })();

    return () => {
      active = false;
    };
  }, [filterValue]);

  return (
    <ProfileContext.Consumer>
      {() => (
        <Box sx={{ background: "#F2F3F1" }}>
          <ProfileHeader />
          <Box sx={{ margin: "0 4%" }}>
            <Box
              borderRadius={5}
              sx={{
                background: "#FFFFFF",
                height: (rows?.length + 1) * 50 + 200,
                pt: 1,
              }}
            >
              <DataGridPremium
                filterModel={gridFilterModel}
                onFilterModelChange={setGridFilterModel}
                localeText={
                  esES.components.MuiDataGrid.defaultProps.localeText
                }
                rows={rows}
                columns={getColumns()}
                loading={loading}
                sortModel={sortModel}
                onSortModelChange={(newModelSort) => setSortModel(newModelSort)}
                components={{
                  Toolbar: CustomToolbar,
                }}
                sx={{
                  border: 0,
                  "& .super-app-theme--header": {
                    fontWeight: "900",
                  },
                }}
              />
            </Box>
          </Box>
          <ProfileBottomNav goBack={true} />
        </Box>
      )}
    </ProfileContext.Consumer>
  );
}
